<template>
    <attended-interview-listing/>
</template>
<script>
import AttendedInterviewListing from '../../common-components/AttendedInterviewListing';
export default {
    components: { AttendedInterviewListing }
};
</script>
